<template>
    <section role="document" aria-labelledby="user-guide-heading">
        <b-container class="col-9 mt-5" style="padding:0px 9% 0 9%;">
            <div v-to-lang.children>
                <h1 id="user-guide-heading" tabindex="-1" class="ug-heading">
                    <span v-html="$t('main-heading')"></span>
                </h1>

                <p class="text-justify lead">
                    <b>
                        <span style='font-size:14.0pt;line-height:115%;color:#4A86E8'></span>
                    </b>
                </p>

                <p class="sub-heading">
                    <b>
                        <span style='font-size:14.0pt;line-height:115%;color:#4A86E8'>
                            <span>
                                <span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span>{{$t('one')}}.<span style='font:7.0pt "Times New Roman"'>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </span>
                            </span>
                        </span>
                    </b><b>
                        <span style='font-size:14.0pt;line-height:115%;color:#4A86E8'>
                            {{$t('sub-heading-1')}}
                        </span>
                    </b>
                </p>



                <p class="text-justify lead" v-html="$t('sub-heading-1-para-1')">

                </p>



                <p class="text-justify lead ml-5">
                    <span>
                        <span class="bullet">
                            &#9679;<span style='font:7.0pt "Times New Roman"'>

                            </span>
                        </span>
                    </span>
                    <span v-html="$t('sub-heading-1-para-point-1')"></span>
                </p>

                <p class="text-justify lead ml-5">
                    <span>
                        <span class="bullet">
                            &#9679;<span style='font:7.0pt "Times New Roman"'>

                            </span>
                        </span>
                    </span>
                    <span v-html="$t('sub-heading-1-para-point-2')"></span>
                </p>

                <p class="text-justify lead ml-5">
                    <span>
                        <span class="bullet">
                            &#9679;<span style='font:7.0pt "Times New Roman"'>

                            </span>
                        </span>
                    </span>
                    <span v-html="$t('sub-heading-1-para-point-3')"></span>
                </p>

                <p class="text-justify lead" v-html="$t('sub-heading-1-para-2')">

                </p>



                <p class="text-justify lead ml-5">
                    <span>
                        <span class="bullet">
                            &#9679;<span style='font:7.0pt "Times New Roman"'>

                            </span>
                        </span>
                    </span>
                    <span v-html="$t('sub-heading-1-para-2-point-1')"></span>
                </p>

                <p class="text-justify lead ml-5">
                    <span>
                        <span class="bullet">
                            &#9679;<span style='font:7.0pt "Times New Roman"'>

                            </span>
                        </span>
                    </span>
                    <span v-html="$t('sub-heading-1-para-2-point-2')"></span>
                </p>





                <span align="center" class="d-flex flex-column">
                    <span >
                        <img style="width:60%" :src="basePath + `/images/user-guide-${getCurrentLanguage}/image001.png`" :alt="$t('para-1-img-alt')" class="mt-5">
                    </span>
                    <span >{{$t('para-1-img-q-tip')}}</span>
                </span>


                <p style='margin-top:0in;text-indent:.5in;line-height:115%'>
                    <span></span>
                </p>

                <p class="sub-heading">
                    <b>
                        <span style='font-size:14.0pt;line-height:115%;color:#4A86E8'>
                            <span>
                                {{$t('two')}}.<span style='font:7.0pt "Times New Roman"'>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </span>
                            </span>
                        </span>
                    </b><b>
                        <span style='font-size:14.0pt;line-height:115%;color:#4A86E8'>
                            {{$t('sub-heading-2')}}
                        </span>
                    </b>
                </p>



                <p class="text-justify lead" v-html="$t('sub-heading-2-para-1')">

                </p>

                <p class="text-justify lead ml-5">
                    <span>
                        <span class="bullet">
                            &#9679;<span style='font:7.0pt "Times New Roman"'>

                            </span>
                        </span>
                    </span>
                    <span v-html="$t('sub-heading-2-para-1-point-1')"></span>
                </p>
                <p class="text-justify lead ml-5">
                    <span>
                        <span class="bullet">
                            &#9679;<span style='font:7.0pt "Times New Roman"'>

                            </span>
                        </span>
                    </span>
                    <span v-html="$t('sub-heading-2-para-1-point-2')"></span>
                </p>
                <p class="text-justify lead ml-5">
                    <span>
                        <span class="bullet">
                            &#9679;<span style='font:7.0pt "Times New Roman"'>

                            </span>
                        </span>
                    </span>
                    <span v-html="$t('sub-heading-2-para-1-point-3')"></span>
                </p>
                <p class="text-justify lead ml-5">
                    <span>
                        <span class="bullet">
                            &#9679;<span style='font:7.0pt "Times New Roman"'>

                            </span>
                        </span>
                    </span>
                    <span v-html="$t('sub-heading-2-para-1-point-4')"></span>
                </p>

                <p class="text-justify lead ml-5">
                    <span>
                        <span class="bullet">
                            &#9679;<span style='font:7.0pt "Times New Roman"'>

                            </span>
                        </span>
                    </span>
                    <span v-html="$t('sub-heading-2-para-1-point-5')"></span>
                </p>
                <p class="text-justify lead" v-html="$t('sub-heading-2-para-2')">

                </p>

                <p align="center">
                    <span>
                        <img style="width:60%" :src="basePath + `/images/user-guide-${getCurrentLanguage}/image003.png`" :alt="$t('para-2-img-alt')" class="mt-5">
                    </span>
                </p>


                <p style='margin-top:0in;text-indent:.5in;line-height:115%'>
                    <span></span>
                </p>
                <p class="sub-heading">
                    <b>
                        <span style='font-size:14.0pt;line-height:115%;color:#4A86E8'>
                            <span>
                                {{$t('three')}}.<span style='font:7.0pt "Times New Roman"'>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </span>
                            </span>
                        </span>
                    </b><b>
                        <span style='font-size:14.0pt;line-height:115%;color:#4A86E8'>
                            {{$t('sub-heading-3')}}
                        </span>
                    </b>
                </p>

                <p class="text-justify lead" v-html="$t('sub-heading-3-para')">

                </p>

                <p align=center style='margin-top:0in;text-align:center;line-height:115%'>
                    <span>
                        <img style="width:60%" :src="basePath + `/images/user-guide-${getCurrentLanguage}/image005.png`" :alt="$t('para-3-img-alt')" class="mt-5">
                    </span>
                </p>

                <p align=center style='margin-top:0in;text-align:center;line-height:115%'><span></span></p>



                <p style='margin-top:0in;text-indent:.5in;line-height:115%'>
                    <span></span>
                </p>

                <p class="sub-heading">
                    <b>
                        <span style='font-size:14.0pt;line-height:115%;color:#4A86E8'>
                            <span>
                                {{$t('four')}}.<span style='font:7.0pt "Times New Roman"'>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </span>
                            </span>
                        </span>
                    </b><b>
                        <span style='font-size:14.0pt;line-height:115%;color:#4A86E8'>
                            {{$t('sub-heading-4')}}
                        </span>
                    </b>
                </p>



                <p class="text-justify lead" v-html="$t('sub-heading-4-para-1')">
                </p>

                <p style='margin-top:0in;text-indent:.5in;line-height:115%'>
                    <span></span>
                </p>

                <p align=center style='margin-top:0in;text-align:center;text-indent:.5in;line-height:115%'>
                    <span>
                        <img style="width:60%" :src="basePath + `/images/user-guide-${getCurrentLanguage}/image007.png`" :alt="$t('para-4-img-alt')" class="mt-5">
                    </span>
                </p>

                <p align=center style='margin-top:0in;text-align:center;text-indent:.5in;line-height:115%'><span></span></p>



                <p class="text-justify lead" v-html="$t('para-4-footer-para-1')">
                </p>

                <p style='margin-top:0in;text-indent:.5in;line-height:115%'>
                    <span></span>
                </p>

                <p align=center style='margin-top:0in;text-align:center;text-indent:.5in;line-height:115%'>
                    <span>
                        <img style="width:60%" :src="basePath + `/images/user-guide-${getCurrentLanguage}/image009.png`" :alt="$t('para-4-img-alt-2')" class="mt-5">
                    </span>
                </p>

                <p align=center style='margin-top:0in;text-align:center;text-indent:.5in;line-height:115%'><span></span></p>


                <p style='margin-top:0in;text-indent:.5in;line-height:115%'>
                    <span></span>
                </p>

                <p style='margin-top:0in;text-indent:.5in;line-height:115%'>
                    <span></span>
                </p>

                <p class="sub-heading">
                    <b>
                        <span style='font-size:14.0pt;line-height:115%;color:#4A86E8'>
                            <span>
                                <span style='font:7.0pt "Times New Roman"'>&nbsp; </span>{{$t('five')}}.<span style='font:7.0pt "Times New Roman"'>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </span>
                            </span>
                        </span>
                    </b><b>
                        <span style='font-size:14.0pt;line-height:115%;color:#4A86E8'>
                            {{$t('sub-heading-5')}}
                        </span>
                    </b>
                </p>



                <p class="text-justify lead" v-html="$t('sub-heading-5-para-1')">
                </p>

                <p style='margin-top:0in;text-indent:.5in;line-height:115%'>
                    <span></span>
                </p>

                <p align=center style='margin-top:0in;text-align:center;text-indent:.5in;line-height:115%'>
                    <span>
                        <img style="width:60%" :src="basePath + `/images/user-guide-${getCurrentLanguage}/image011.png`" :alt="$t('sub-heading-5-img-alt')" class="mt-5">
                    </span>
                </p>

                <p align=center style='margin-top:0in;text-align:center;text-indent:.5in;line-height:115%'><span></span></p>


                <p style='margin-top:0in;text-indent:.5in;line-height:115%'>
                    <span></span>
                </p>

                <p style='margin-top:0in;text-indent:.5in;line-height:115%'>
                    <span></span>
                </p>

                <p class="text-justify lead" v-html="$t('sub-heading-5-footer-para-1')">
                </p>

                <p style='margin-top:0in;text-indent:.5in;line-height:115%'>
                    <span></span>
                </p>

                <p align=center style='margin-top:0in;text-align:center;text-indent:.5in;line-height:115%'>
                    <span>
                        <img style="width:60%" :src="basePath + `/images/user-guide-${getCurrentLanguage}/image013.png`" :alt="$t('sub-heading-5-img-alt-2')" class="mt-5">
                    </span>
                </p>

                <p align=center style='margin-top:0in;text-align:center;text-indent:.5in;line-height:115%'><span></span></p>


                <p align=center style='margin-top:0in;text-align:center;text-indent:.5in;line-height:115%'><span></span></p>

                <p class="text-justify lead" v-html="$t('sub-heading-5-footer-para-2')">
                </p>

                <p style='margin-top:0in;text-indent:.5in;line-height:115%'>
                    <span></span>
                </p>

                <p align=center style='margin-top:0in;text-align:center;text-indent:.5in;line-height:115%'>
                    <span>
                        <img style="width:60%" :src="basePath + `/images/user-guide-${getCurrentLanguage}/image015.png`" :alt="$t('sub-heading-5-img-alt-3')" class="mt-5">
                    </span>
                </p>

                <p align=center style='margin-top:0in;text-align:center;text-indent:.5in;line-height:115%'><span></span></p>


                <p align=center style='margin-top:0in;text-align:center;text-indent:.5in;line-height:115%'><span></span></p>

                <p align=center style='margin-top:0in;text-align:center;text-indent:.5in;line-height:115%'>
                    <span>
                        <img style="width:60%" :src="basePath + `/images/user-guide-${getCurrentLanguage}/image017.png`" :alt="$t('sub-heading-5-img-alt-4')" class="mt-5">
                    </span>
                </p>



                <p style='margin-top:0in;text-indent:.5in;line-height:115%'>
                    <span></span>
                </p>

                <p class="sub-heading">
                    <b>
                        <span style='font-size:14.0pt;line-height:115%;color:#4A86E8'>
                            <span>
                                {{$t('six')}}.<span style='font:7.0pt "Times New Roman"'>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </span>
                            </span>
                        </span>
                    </b>
                    <b>
                        <span style='font-size:14.0pt;line-height:115%;color:#4A86E8'>
                            {{$t('sub-heading-6')}}
                        </span>
                    </b>
                </p>



                <p class="text-justify lead" v-html="$t('sub-heading-6-para-1')">

                </p>

                <p align=center style='margin-top:0in;text-align:center;text-indent:.5in;line-height:115%'>
                    <span>
                        <img style="width:60%" :src="basePath + `/images/user-guide-${getCurrentLanguage}/image019.png`" class="mt-5">
                    </span>
                </p>

                <p style='margin-top:0in;text-indent:.5in;line-height:115%'>
                    <span></span>
                </p>

                <p class="sub-heading">
                    <b>
                        <span style='font-size:14.0pt;line-height:115%;color:#4A86E8'>
                            <span>
                                {{$t('seven')}}.<span style='font:7.0pt "Times New Roman"'>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </span>
                            </span>
                        </span>
                    </b><b>
                        <span style='font-size:14.0pt;line-height:115%;color:#4A86E8'>
                            {{$t('sub-heading-7')}}
                        </span>
                    </b>
                </p>



                <p class="text-justify lead" v-html="$t('sub-heading-7-para-1')">
                </p>

                <p class="text-justify lead">
                    <b><span></span></b>
                </p>

                <p align=center style='margin-top:0in;text-align:center;line-height:115%'>
                    <span>
                        <img style="width:60%" :src="basePath + `/images/user-guide-${getCurrentLanguage}/image021.png`" :alt="$t('sub-heading-7-img-alt')" class="mt-5">
                    </span>
                </p>

            </div>
        </b-container>
    </section>
</template>
<script>
    declare var UNTERM: any;
    import { mapGetters } from 'vuex'
    import UserGuideTranslation from "../Lang/user-guide-lang"
    export default {
        i18n: {
            messages: {
                ...UserGuideTranslation,
            }
        },
        computed: {
            ...mapGetters([
                'getCurrentLanguage'
            ]),
            basePath() { return UNTERM.BasePath },
        }
    }
</script>
<style>
    .sub-heading {
        margin: 40px 0px 20px 0px;
        text-indent: -0.5in;
        line-height: 115%;
    }

    .i18n-ar .sub-heading, .i18n-ar .ug-heading {
        text-align: right;
    }
    .bullet{
        margin-right:10px;
    }
</style>
